import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=14022f32&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_a2ryrgrddytsl2onh2hza74dqa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\comm\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14022f32')) {
      api.createRecord('14022f32', component.options)
    } else {
      api.reload('14022f32', component.options)
    }
    module.hot.accept("./Tooltip.vue?vue&type=template&id=14022f32&", function () {
      api.rerender('14022f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/components/dg-tooltip/src/Tooltip.vue"
export default component.exports